import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Notificacion } from 'src/app/models/notificacion';

@Component({
  selector: 'app-notificacion-detalle-dialog',
  templateUrl: './notificacion-detalle-dialog.component.html',
  styleUrl: './notificacion-detalle-dialog.component.scss'
})
export class NotificacionDetalleDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<NotificacionDetalleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public notificacion: Notificacion
  ) { }

  cerrar() {
    this.dialogRef.close();
  }
}
